<template>
  <div class="w-screen h-screen m-auto mainDiv">
    <headerBar :mainColor="1"></headerBar>
    <div>
      <div class="m-3">
        <div class="stepTitleHeader hidden md:flex">
          <div
            class="stepsIndicator"
            style="
              width: 230px;
              margin-inline-end: 10px;
              padding-inline: 15px 40px;
            "
          ></div>
          <div
            style="
              margin-inline-start: 20px;
              width: 100%;
              display: flex;
              flex-direction: row;
              padding-inline-end: 40px;
            "
          >
            <div class="steptUpperTitle">
              {{ tabTitles[currentTabIndex]?.title }}
            </div>
            <div class="dashedLineDiv"></div>
          </div>
        </div>
        <div class="stepperWizard grid">
          <div
            class="stepsIndicator col-12 md:col-2 flex flex-row md:flex-column"
          >
            <div
              v-for="(tab, index) in tabTitles"
              class="flex-row md:flex-column"
              :key="index"
            >
              <stepTemplete
                :tab="tab"
                :index="index"
                :mainColor="1"
                :tabLength="tabTitles.length"
                :currentTabIndex="currentTabIndex"
                @click="
                  isSubmitted == 'true' ? onChangeCurrentTab(index) : donothing
                "
                style="cursor: pointer"
              ></stepTemplete>
            </div>
          </div>
          <div class="stepsBody col-12 md:col-9">
            <Basic_Information
              v-if="getStepIdFromIndex(currentTabIndex) === 1"
              @nextPage="onChangeCurrentTab($event)"
            ></Basic_Information>

            <Contact_Information
              v-if="getStepIdFromIndex(currentTabIndex) === 3"
              @nextPage="onChangeCurrentTab($event)"
            ></Contact_Information>

            <Guardian_Information
              v-if="getStepIdFromIndex(currentTabIndex) === 18"
              @nextPage="onChangeCurrentTab($event)"
            ></Guardian_Information>

            <Secondary_School_Qualifications
              @nextPage="onChangeCurrentTab($event)"
              v-if="getStepIdFromIndex(currentTabIndex) === 4"
            ></Secondary_School_Qualifications>

            <Fees_Payment
              v-if="getStepIdFromIndex(currentTabIndex) === 22"
              @nextPage="onChangeCurrentTab($event)"
            ></Fees_Payment>

            <Applicant_Preferences
              v-if="getStepIdFromIndex(currentTabIndex) === 15"
              @nextPage="onChangeCurrentTab($event)"
            ></Applicant_Preferences>

            <Upload_Documents
              v-if="getStepIdFromIndex(currentTabIndex) === 8"
              @nextPage="onChangeCurrentTab($event)"
            ></Upload_Documents>

            <Terms_Conditions
              v-if="getStepIdFromIndex(currentTabIndex) === 16"
              @nextPage="onChangeCurrentTab($event)"
            ></Terms_Conditions>
            <Finished
              v-if="getStepIdFromIndex(currentTabIndex) === 111"
              @nextPage="onChangeCurrentTab($event)"
            ></Finished>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerBar from "../components/custom-components/applicant_application_master/header_bar.vue";
import stepTemplete from "../components/custom-components/applicant_application_master/step_templete.vue";

import Basic_Information from "./application_pages/Basic_Information.vue";
import Contact_Information from "./application_pages/Contact_Information.vue";
import Guardian_Information from "./application_pages/Guardian_Information.vue";
import Secondary_School_Qualifications from "./application_pages/Secondary_School_Qualifications.vue";
import Fees_Payment from "./application_pages/Fees_Payment.vue";
import Applicant_Preferences from "./application_pages/Applicant_Preferences.vue";
import Upload_Documents from "./application_pages/Upload_Documents.vue";
import Terms_Conditions from "./application_pages/Terms_Conditions.vue";

import Finished from "./application_pages/Finished.vue";

export default {
  data() {
    return {
      firstView: true,
    };
  },
  components: {
    headerBar,
    stepTemplete,
    Basic_Information,
    Contact_Information,
    Guardian_Information,
    Secondary_School_Qualifications,
    Fees_Payment,
    Applicant_Preferences,
    Upload_Documents,
    Terms_Conditions,
    Finished,
  },
  computed: {
    isSubmitted() {
      return localStorage.getItem("isSubmitted");
    },
    nextBtnTxt() {
      return this.$t("nextBtnTxt");
    },
    previousBtnTxt() {
      return this.$t("previousBtnTxt");
    },
    currentTabIndex() {
      return this.$store.getters["navigation/getCurrentTabIndex"];
    },
    tabTitles() {
      return this.$store.getters["navigation/getTabTitles"];
    },
  },
  methods: {
    donothing() {},
    getStepIdFromIndex(currentIndex) {
      return this.$store.getters["navigation/getStepIdFromIndex"](currentIndex);
    },
    onChangeCurrentTab(index) {
      console.log(this.tabTitles);
      this.firstView = false;
      this.$store.dispatch("navigation/changeTab", index);
    },
  },
  created() {
    this.$store.dispatch("navigation/fetchStepsData");
  },
};
</script>

<style scoped>
.stepTitleHeader {
  height: 40px;
  width: 100%;
  display: flex;
  flex-direction: row;
}

.steptUpperTitle {
  font-size: 22px;
  font-weight: bold;
  font-family: "Cairo";
  color: var(--main-color);
  margin-inline-end: 10px;
}

.dashedLineDiv {
  border-bottom: 3px dotted var(--main-color);
  height: 20px;
  flex-grow: 1;
}

@media screen and (min-width: 500px) {
  .stepperWizard {
    display: flex;
    flex-direction: row;
    height: 75vh;
    width: 100%;
    padding-inline: 10px;
  }
}
@media screen and (max-width: 500px) {
  .stepperWizard {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-inline: 10px;
  }
}

.stepsIndicator {
  height: 100%;
}

.stepsBody {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 30px #00000012;
  height: 100%;
  border-radius: 10px;
}

:deep(.fw-footer) {
  display: none !important;
}

:deep(.p-inputtext-lg) {
  box-shadow: 0px 3px 10px #0000001a !important;
}
:deep(.p-dropdown-label) {
  color: var(--main-color) !important;
  font-weight: bold;
}

:deep(.p-dropdown-trigger-icon) {
  color: var(--main-color) !important;
  font-weight: bold;
}

:deep(.fw-body-container) {
  height: 100%;
}

:deep(.p-dropdown) {
  border-color: transparent;
  box-shadow: 1px 1px 6px #d5cfcf;
}

:deep(.p-inputtext) {
  color: var(--main-color) !important;
  font-weight: bold;
}

:deep(.fw-vertical) {
  min-height: 85vh !important;
}

:deep(.fw-body-list) {
  width: 260px !important;
}

.mainDiv {
  background-image: url("../assets/images/islamicTextureBg.png");
  background-size: cover;
}

.systemName {
  font-size: 1.5vw;
  font-weight: bold;
  text-align: center;
}

.infoLinkSpan {
  text-align: center;
  text-decoration: underline;
  letter-spacing: 0px;
  color: #028bff;
  text-transform: capitalize;
  margin: 5px 10px;
}

.footer {
  margin-bottom: 20px;
  text-align: center;
}

.tabPageName {
  margin-inline-start: 250px;
  color: var(--main-color);
}
/*******start of  steps********/

:deep(.fw-body-content) {
  padding: 10px 30px !important;
  background-color: white !important;
  margin-inline: 30px !important;
  box-shadow: 1px 2px 10px #8080806b !important;
  width: auto !important;
  border-radius: 15px;
}
.form-wizard-vue {
  background-color: transparent !important;
}
.fw-card {
  box-shadow: none;
  border: none;
}
/*******end of  steps********/
</style>
